import { FunctionalityFormDataWithName } from '@features/Funnel/screens/FunnelPage/Functionality/FunctionalityPageScreen';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { functionalityPayloadFactory } from '../../utils/functionalityFunnelsPageFactory';

interface UpdateFunctionalityFunnelPageRequest {
  id: string;
  payload: FunctionalityFormDataWithName;
}
export function useTryToRequestUpdateFunctionalityPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({
      id,
      payload,
    }: UpdateFunctionalityFunnelPageRequest) => {
      const factory = await functionalityPayloadFactory(payload);

      return await apiCancellationFunnels.tryToRequestUpdateCancellationFunnelPage(
        id,
        factory
      );
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao editar o funil de Perguntas',
        'Ocorreu um erro ao editar o funil de Perguntas, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestUpdateFunctionalityPage: mutateAsync,
    isLoadingFunctionalityUpdate: isPending,
  };
}
